import superagentPromisePlugin from 'superagent-promise-plugin'

import http_agent from './http_agent'
import config from 'config'

function getStates() {
	const url = config.services + 'state/get.php'
	return http_agent.get(url)
		.withCredentials()
		.use(superagentPromisePlugin)
		.then(function(res) {
			return JSON.parse(res.text).payload.states
		})
		.catch(function(err) {
			return err.response
		})
}

export default {
	getStates,
}
